import { memo, useMemo } from "react";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { Checkbox, TooltipIcon } from "@components";
import { Grid } from "@material-ui/core";
import { Percent } from "@assets";

export const WorkTypeCheckbox = memo(({
  id,
  name,
  checked,
  usedInSections,
  onChange,
  editedWorkTypeName,
  percentageWorkTypes,
  showPercentageWorkTypesTooltip,
  disabled,
}) => {
  const { t } = useTranslation();
  
  const isDisabled = useMemo(() => (
    disabled || Boolean(usedInSections?.length)
  ), [disabled, usedInSections?.length]);
  
  const percentRelationList = useMemo(() => (
    percentageWorkTypes?.map(workType => workType.name || t("common.unnamed"))?.join(", ")
  ), [percentageWorkTypes]);
  
  return (
    <Grid item container className="gap-2">
      <Checkbox
        name={`count${id}`}
        aria-label={name}
        checked={checked}
        disabled={isDisabled}
        onChange={onChange}
        className="m-0"
        label={name}
      />
      {
        Boolean(editedWorkTypeName) && isDisabled &&
        <TooltipIcon
          color="primary"
          placement="right"
        >
          <p className="text-sm">
            {t("views.editor.dialogs.automation.used_in_sections", { wTName: editedWorkTypeName, targetWTName: name })}
            <strong>
              { usedInSections.join(", ") }
            </strong>
          </p>
          
        </TooltipIcon>
      }
      {
        Boolean(percentRelationList) && showPercentageWorkTypesTooltip &&
        <TooltipIcon
          color="primary"
          placement="right"
          icon={<Percent />}
        >
          { t("views.editor.dialogs.automation.calculated_from", { list: percentRelationList }) }
        </TooltipIcon>
      }
    </Grid>
  );
});

WorkTypeCheckbox.propTypes = {
  id: number.isRequired,
  name: string.isRequired,
  percentageWorkTypes: arrayOf(shape({
    id: number.isRequired,
    name: string,
  })),
  editedWorkTypeName: string,
  onChange: func.isRequired,
  usedInSections: arrayOf(string),
  checked: bool,
  showPercentageWorkTypesTooltip: bool,
  disabled: bool,
};